import React from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";

export function UserProfileNav(): JSX.Element {
    const { t } = useTranslation();
    const router = useRouter();
    const isActive = (href: string): string =>
        router.asPath == href ? "active" : "";

    return (
        <div className="userProfileNav py-4">
            <ul>
                <li className={isActive("/profile")}>
                    <Link href="/profile">
                        <a className="profile">{t("common:user.profile")}</a>
                    </Link>
                </li>
                <li className={isActive("/profile/ticket/times")}>
                    <Link href="/profile/ticket/times">
                        <a className="myTicket">{t("common:user.ticket")}</a>
                    </Link>
                </li>
                <li className={isActive("/profile/invoice")}>
                    <Link href="/profile/invoice">
                        <a className="accounting">{t("common:user.invoice")}</a>
                    </Link>
                </li>
                {/* <li>
        <span className="accounting">{t("common:user.accounting")}</span>
      </li> */}
                <li className={isActive("/profile/password")}>
                    <Link href="/profile/password">
                        <a className="changePass">
                            {t("common:user.password")}
                            {/* <span className="changepass-child">{t("common:user.lastchange")}: Jan13,2018</span> */}
                        </a>
                    </Link>
                </li>
            </ul>
        </div>
    );
}

export default React.memo(UserProfileNav);
